import { RequestParams, useRequest } from "../use-request";
import { useEffect, useState } from "react";

const CHECKOUT_API_HOST = process.env.GATSBY_CHECKOUT_API_URL;
const API_URL = `${CHECKOUT_API_HOST}/get-account-credits`;
import useAuth from "../../hooks/use-auth";

export interface CreditsInterface {
  credits: number;
  isLoading: boolean;
  error?: string;
}

type HookParams = {
  getTokenID: () => Promise<string>;
};

export const useCredits = (): CreditsInterface => {
  const { getTokenID } = useAuth();
  const params = {
    getTokenID,
  }
  const [credits, setCredits] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>(undefined);

  const request = useRequest(createRequestParams(params));

  useEffect(() => {
    if (request) setIsLoading(request.isLoading);
  }, [request?.isLoading]);

  useEffect(() => {
    if (request?.data) {
      const responseData = request.data as { data: number };

      setCredits(responseData.data);
    }
    if (request?.error) {
      setError("Please try again.");
    };
  }, [request?.data]);

  return {
    credits,
    isLoading,
    error,
  };
};

const createRequestParams = ({
  getTokenID,
}: HookParams): RequestParams => {
  return {
    url: API_URL,
    getTokenID,
  };
};
